import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Tr,
  Td,
  Label,
  Input,
  MaximunQuantityNote,
  DisabledOverlay
} from './css';
import getFormattedPricing from '../../utils';
import FieldGuide from '../../../../form/fields/common/fieldGuide';

const Row = ({
  rowData,
  viewType,
  addons,
  setAddons,
  hasServiceColumn,
  serviceLabel,
  renderServiceCell,
  serviceRowSpan
}) => {
  const {
    fields: {
      addonName,
      unitPrice,
      isThePriceForDueNow,
      maxUnits,
      hideItemForSimpleView,
      toolTip,
      hideUntilAllServicesSelected
    }
  } = rowData;

  const isRowDisabled = hideUntilAllServicesSelected
    ? hideUntilAllServicesSelected.every(item => {
        const {
          fields: { addonName: addonServiceName }
        } = item;
        return !_.get(addons, `${addonServiceName}.quantity`, 0);
      })
    : false;

  if (viewType === 'simpleView' && hideItemForSimpleView) return null;

  const [quantity, setQuantity] = useState(() =>
    _.get(addons, `${addonName}.quantity`, 0)
  );
  const isComponentMounted = useRef(false);
  const rowRef = useRef(false);

  const handleQuantityChange = e => {
    const {
      target: { value }
    } = e;
    if (isRowDisabled) setQuantity(0);
    else if (maxUnits && +value > maxUnits) setQuantity(maxUnits);
    else setQuantity(+value);
  };

  useEffect(() => {
    if (!isComponentMounted.current) {
      isComponentMounted.current = true;
      return;
    }

    const updatedRatePlans = {
      ...addons,
      [addonName]: {
        quantity,
        unitPrice,
        isThePriceForDueNow
      }
    };
    setAddons(updatedRatePlans);
  }, [quantity, unitPrice, isThePriceForDueNow]);

  useEffect(() => {
    if (viewType && rowRef.current) {
      setQuantity(0);
    }
    rowRef.current = true;
  }, [viewType]);

  useEffect(() => {
    if (isRowDisabled) setQuantity(0);
  }, [isRowDisabled]);

  return (
    <Tr className={isRowDisabled && 'disabled-row'}>
      {hasServiceColumn && renderServiceCell && (
        <Td
          rowSpan={serviceRowSpan}
          style={{ background: '#f7f7f7', fontWeight: '700' }}
        >
          <Label>{serviceLabel}</Label>
        </Td>
      )}
      <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
        {isRowDisabled && <DisabledOverlay />}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
          <Label isDisabled={isRowDisabled}>{addonName}</Label>
          {toolTip && (
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
              <FieldGuide tooltip={toolTip} />
            </div>
          )}
        </div>
      </Td>
      <Td>
        <Input
          // type="number"
          autocomplete="off"
          isDisabled={isRowDisabled}
          className="frg-input-field color-light"
          pattern="[0-9]"
          value={quantity}
          onChange={handleQuantityChange}
          disabled={isRowDisabled}
        />
        {maxUnits && (
          <MaximunQuantityNote>
            Maximun of {maxUnits} unit can be selected
          </MaximunQuantityNote>
        )}
      </Td>
      <Td>
        <Label isDisabled={isRowDisabled}>
          {getFormattedPricing(unitPrice)}
        </Label>
      </Td>
      <Td>
        <Label isDisabled={isRowDisabled}>
          {getFormattedPricing(unitPrice * quantity)}
        </Label>
      </Td>
    </Tr>
  );
};

Row.propTypes = {
  rowData: PropTypes.shape({
    fields: PropTypes.shape({
      addonName: PropTypes.string,
      unitPrice: PropTypes.number,
      isThePriceForDueNow: PropTypes.bool,
      maxUnits: PropTypes.number,
      hideItemForSimpleView: PropTypes.bool,
      toolTip: PropTypes.string,
      hideUntilAllServicesSelected: PropTypes.arrayOf(PropTypes.shape({}))
    })
  }).isRequired,
  viewType: PropTypes.string.isRequired,
  addons: PropTypes.shape({}).isRequired,
  setAddons: PropTypes.func.isRequired,
  hasServiceColumn: PropTypes.bool,
  serviceLabel: PropTypes.string,
  renderServiceCell: PropTypes.bool,
  serviceRowSpan: PropTypes.number
};

Row.defaultProps = {
  hasServiceColumn: false,
  serviceLabel: '',
  renderServiceCell: false,
  serviceRowSpan: 1
};

export default Row;
